module.exports = __webpack_public_path__ + "static/media/mp_theatre.15eff59e.jpg";